export default $fetch.create({
  retry: 0,
  responseType: 'json',
  retryStatusCodes: [],
  baseURL: '/landing/api/',
  onRequest(ctx) {
    const { headerName, csrf } = useCsrf()

    ctx.options.headers.set(headerName, csrf)
  },
  headers: {
    'Content-Type': 'application/json',
  },
})
